/** Minutes from now to the given ISO time (positive = future). */
export function getRelativeMinutes(iso: string, now = Date.now()): number {
  return Math.round((new Date(iso).getTime() - now) / 60000);
}

/** Calendar days from today (local) to the ISO date. */
export function calendarDaysFromToday(iso: string, now = new Date()): number {
  const date = new Date(iso);
  const departureDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.floor(
    (departureDate.getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24),
  );
}
